import React from 'react';
import { Card, CardBody } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import { BUCKET_COLORS, BUCKET_ORDER } from './dashboardProdutosHelpers';

const MarcoOverviewChart = ({
  overview,
  activeFilter,
  onBarClick,
}) => {
  const { marco, counts, total } = overview;
  const labels = BUCKET_ORDER.map((key) => marco.labels[key]);
  const values = BUCKET_ORDER.map((key) => counts[key] || 0);
  const colors = BUCKET_ORDER.map((key) => BUCKET_COLORS[key]);

  const options = {
    labels,
    chart: {
      events: {
        dataPointSelection: (_event, _chartContext, config) => {
          const bucket = BUCKET_ORDER[config.dataPointIndex];
          if (bucket && onBarClick) onBarClick(marco.id, bucket);
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    colors,
    tooltip: {
      y: {
        formatter: (v) => `${v} produto(s)`,
      },
    },
  };

  const isActive = (bucket) =>
    activeFilter?.marcoId === marco.id && activeFilter?.bucket === bucket;

  return (
    <Card
      style={{
        border: activeFilter?.marcoId === marco.id ? '2px solid #505A62' : undefined,
        height: '100%',
      }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="font-size-14 mb-0" style={{ fontWeight: 700 }}>
            {marco.title}
          </h5>
          <span style={{ fontWeight: 700, fontSize: '22px' }}>{total}</span>
        </div>
        <p className="text-muted mb-2" style={{ fontSize: '11px' }}>
          Clique em uma fatia para filtrar a tabela abaixo
        </p>
        {total === 0 ? (
          <p className="text-center text-muted mb-0" style={{ fontSize: '12px', padding: '24px 0' }}>
            Nenhum produto com data limite neste mês
          </p>
        ) : (
          <div id="donut-chart" className="apex-charts mt-3">
            <ReactApexChart
              options={options}
              series={values}
              type="pie"
              height="230"
            />
          </div>
        )}
        <div className="d-flex flex-wrap mt-1" style={{ gap: 6 }}>
          {BUCKET_ORDER.map((bucket) => (
            <span
              key={bucket}
              role="button"
              tabIndex={0}
              onClick={() => onBarClick && onBarClick(marco.id, bucket)}
              onKeyDown={(e) => e.key === 'Enter' && onBarClick && onBarClick(marco.id, bucket)}
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                borderRadius: 4,
                cursor: 'pointer',
                backgroundColor: isActive(bucket) ? BUCKET_COLORS[bucket] : 'transparent',
                color: isActive(bucket) ? '#fff' : '#6c757d',
                border: `1px solid ${BUCKET_COLORS[bucket]}`,
              }}
            >
              {marco.labels[bucket]}: {counts[bucket] || 0}
            </span>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default MarcoOverviewChart;
